import React from 'react';
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './contexts/AuthContext';
import AppRoutes from './routes';
import { SidebarProvider } from "./contexts/SidebarContext";

const App = () => (
  <AuthProvider>
    <SidebarProvider>
      <AppRoutes />
      <ToastContainer
        position="top-right"
        autoClose={4000}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss={false}
        limit={4}
        theme="light"
      />
    </SidebarProvider>
  </AuthProvider>
);

export default App;
